import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21.99 6.86L12 1 2 6.86V20h20l-.01-13.14zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z"
}), 'DraftsSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DraftsSharp.js
// module id = 3266
// module chunks = 2